/**
 * era.ts — the BC/AD abbreviations, per interface language.
 *
 * Four places used to hardcode the Danish "f.Kr.", which then appeared in
 * the English, Finnish and Celtic interfaces: HistoricalContext, DidYouKnow,
 * PeriodTimeline and exploreEnrich. They all call in here instead now.
 *
 * The Celtic languages fall back to BC/AD rather than to a guess, matching
 * how the rest of their untranslated strings fall back to English.
 */
import type { Lang } from "../types/index.ts";

const BC: Partial<Record<Lang, string>> = { en: "BC", fi: "eKr.", cy: "BC", ga: "BC", gd: "BC" };
const AD: Partial<Record<Lang, string>> = { en: "AD", fi: "jKr.", cy: "AD", ga: "AD", gd: "AD" };

/** "BC" in English, "eKr." in Finnish, "f.Kr." in the Nordic languages. */
export function bc(lang: string): string {
  return BC[lang as Lang] ?? "f.Kr.";
}

/** The counterpart to `bc`: "AD", "jKr.", "e.Kr.". */
export function ad(lang: string): string {
  return AD[lang as Lang] ?? "e.Kr.";
}

/** A negative year rendered as "1700 BC" / "1700 f.Kr.". */
export function formatBcYear(year: number, lang: string): string {
  return `${Math.abs(year)} ${bc(lang)}`;
}

/** Expand the `{bc}` and `{ad}` placeholders in a curated year range. */
export function localiseEra(range: string, lang: string): string {
  return range.replace(/\{bc\}/g, bc(lang)).replace(/\{ad\}/g, ad(lang));
}
